// src/slices/1-auth/2-myProfile/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// 🔹 Get Profile
export const getMyProfile = createAsyncThunk("profile/getMyProfile", async (_, { rejectWithValue }) => {
  try {
    const authUser = JSON.parse(sessionStorage.getItem("authUser"));


    const token = authUser?.data?.token;


    const response = await axios.get(`${API_URL}/user/me`, { headers: { Authorization: token } });

    return response.data;
  } catch (error) {

    return rejectWithValue(error?.response?.data?.message || "Failed to load profile");
  }
});
// 🔹 Update Profile
export const updateMyProfile = createAsyncThunk("profile/updateMyProfile", async (profileData, { rejectWithValue }) => {
  try {
    const tokenData = JSON.parse(sessionStorage.getItem("authUser"));
    let token = tokenData?.data?.token?.replace("Bearer ", "");

    const response = await axios.put(`${API_URL}/user/myProfile`, profileData, { headers: { Authorization: `${token}` } });

    return response.data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message || "Failed to update profile");
  }
});
